import * as React from 'react';
import { connect } from 'react-redux';
import * as TIModule from 'Modules/TerminalInstallationModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { withTranslation  } from 'react-i18next';
import { RootState } from 'Redux/Reducers/_RootReducer';
import { HistoryCollisionSelectors } from 'Redux/Selectors/CollisionSelectors';
import * as Dictionary from '../../../Models/Dictionary';
import { EnumTypes as PageEnumTypes } from '../../../Models/EnumTypes/PageEnumTypes';
import { IParentDetailsProps } from 'components/Layout/DetailsSidebar/ParentDetails';
import {appURL} from '../../../Connectors/_main'
import { NavLink } from 'react-router-dom';
import {setCollisionToken, pullExternalUrl} from 'Redux/Actions/CollisionActions'
import * as EnumTypes from '../../../Models/EnumTypes/ViewManagementEnumTypes';
interface IP extends IParentDetailsProps {
    history: any;
}
type ConnectedP = {
    activeEl: TIModule.Types.TerminalInstallationOrderDto;
    tokenCollision:any;
};
type DispatchedP = {
    pullExternalUrl: (id:number) => void;
    showPopup:(popupData: ViewManagementModule.Types.Popup)=>void
};

type S = {};

class CollisionListDetails extends React.Component<IP & ConnectedP & DispatchedP, S> {

    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    private goToDetails() {
        if(this.props.activeEl) {
            this.props.history.push(`${Dictionary.PageUrl.get(PageEnumTypes.Page.COLLISION)}/${this.props.activeEl.id}`);
        }   
    }

    private async generateExternalUrl() {
        if(this.props.activeEl) {
            await this.props.pullExternalUrl(this.props.activeEl.id)
            const { PopupType } = ViewManagementModule.VMEnumTypes;
            const {tokenCollision} = this.props;

            this.props.showPopup({
                type: PopupType.COLLISION_URL_EXTERNAL,
                template:EnumTypes.PopupTemplate.OK_TEMPLATE,
                confirmCallback: () => {
                   //ll 
                },
                extraContent:<a className={"popup__description__link"} href={`${appURL}${Dictionary.PageUrl.get(PageEnumTypes.Page.COLLISION_WITH_TOKEN)}/${tokenCollision}`}>{appURL}{Dictionary.PageUrl.get(PageEnumTypes.Page.COLLISION_WITH_TOKEN)}/{tokenCollision}</a>
            });      
        } 
    }

    public render() {
        const { t, activeEl } = this.props;

        const classNameGoToDetails = activeEl ? '':' details-right__dashboard-item--disabled ';
        const classNameGoToExternalUrlDetails = activeEl ? '':' details-right__dashboard-item--disabled ';

        return (
            <div className="details-right__dashboard">
                <div className={`details-right__dashboard-item ${classNameGoToDetails}`} onClick={() => this.goToDetails()}>
                    <img src={`/images/icons/arrow.svg`} alt="" className="details-right__dashboard-icon details-right__dashboard-icon--rotate"/>
                    <span>{t('tables:details')}</span>
                </div>

                <div className={`details-right__dashboard-item ${classNameGoToExternalUrlDetails}`} onClick={() => this.generateExternalUrl()}>
                    <img src={`/images/icons/arrow.svg`} alt="" className="details-right__dashboard-icon"/>
                    <span>Wygeneruj link</span>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: RootState): ConnectedP {
    return {
        activeEl: HistoryCollisionSelectors.getActiveCollision(state),
        tokenCollision:state.historyCollision.collisionToken
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        pullExternalUrl: (collisionId: number) => dispatch(pullExternalUrl(collisionId)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData))
    };
}
export default withTranslation (['carDetails', 'tables', 'form'])(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(CollisionListDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/CollisionListDetails.tsx